export default __webpack_public_path__ + "static/media/tab1-image1.fdff1978.png";